import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "dataTypeSelect",

    "stringWrapper",
    "arrayWrapper",
    "dateWrapper",
    "numberWrapper",

    "stringValue",
    "arrayValue",
    "dateValue",
    "numberValue",

    "valueInput",

    "stringValueHelp",
    "arrayValueHelp",
    "dateValueHelp",
    "numberValueHelp"
  ]

  connect() {
    this.toggleValueInputs()
  }

  toggleValueInputs() {
    const type = this.dataTypeSelectTarget.value
    this.hideAll()

    let wrapper, input, help

    switch (type) {
      case "string":
        wrapper = this.stringWrapperTarget
        input   = this.stringValueTarget
        help    = this.stringValueHelpTarget
        break
      case "array":
        wrapper = this.arrayWrapperTarget
        input   = this.arrayValueTarget
        help    = this.arrayValueHelpTarget
        break
      case "date":
        wrapper = this.dateWrapperTarget
        input   = this.dateValueTarget
        help    = this.dateValueHelpTarget
        break
      case "number":
        wrapper = this.numberWrapperTarget
        input   = this.numberValueTarget
        help    = this.numberValueHelpTarget
        break
    }

    if (wrapper) wrapper.classList.remove("hidden")
    if (help) help.classList.remove("hidden")

    if (input) this.syncValue({ target: input })
  }

  hideAll() {
    this.stringWrapperTarget.classList.add("hidden")
    this.arrayWrapperTarget.classList.add("hidden")
    this.dateWrapperTarget.classList.add("hidden")
    this.numberWrapperTarget.classList.add("hidden")

    this.stringValueHelpTarget.classList.add("hidden")
    this.arrayValueHelpTarget.classList.add("hidden")
    this.dateValueHelpTarget.classList.add("hidden")
    this.numberValueHelpTarget.classList.add("hidden")
  }

  syncValue(event) {
    const el = event.target
    if (el.multiple) {
      this.valueInputTarget.value =
          JSON.stringify(Array.from(el.selectedOptions).map(o => o.value))
    } else {
      this.valueInputTarget.value = el.value
    }
  }
}
